import { trackData } from './trackData'
import { encryptByDES } from './crypto'
import request from '@/http/axios'

export const trackStatistics = (data) => {
  const trackDataDefult = trackData()
  const newTrackData = Object.assign({}, trackDataDefult, data)
  const newTrackData2 = encryptByDES(
    JSON.stringify(newTrackData),
    '9b5e5022d8850c31a6326fe75134b'
  )
  const isDebugger = location.search.includes('debugger')

  if (isDebugger) {
    console.log(
      'TrackData:',
      newTrackData.event_code,
      '\n==============\n',
      newTrackData
    )
  }

  const href = window.location.href
  let logUrl = 'https://cloud.woordee.com/track/tr/log'
  if (href.includes('dev') || href.includes('local')) {
    logUrl = 'https://cloud.qa.iol8.net/track/tr/log'
  } else if (href.includes('qa') || href.includes('release')) {
    logUrl = 'https://cloud.qa.iol8.net/track/tr/log'
  }

  return request({
    url: logUrl,
    method: 'post',
    data: {
      param: newTrackData2,
    },
  })
}
